export default __webpack_public_path__ + "static/allsettings-7884218fde8c493ad4b415c128b13629.png";